
export default class FormValueGetter {
  // TODO: extract specific class to each question type

  constructor(questionCard) {
    this.questionCard = questionCard
    this.questionKind = questionCard.getAttribute('data-question-kind')
    this.questionId = questionCard.getAttribute('data-question-id')
  }

  getValue() {
    if (['text_field', 'integer_field'].includes(this.questionKind)) { return this.textFieldValue() }
    if (this.questionKind === 'text_area') { return this.textAreaFieldValue() }
    if (this.questionKind === 'gender') { return this.genderFieldValue() }
    if (this.questionKind === 'radio') { return this.radioFieldValue() }
    if (this.questionKind === 'boolean') { return this.booleanFieldValue() }
    if (this.questionKind === 'check_with_others_option') { return this.checkWithOthersOptionFieldValue() }
    if (this.questionKind === 'check') { return this.checkFieldValue() }
    if (this.questionKind === 'boolean_with_complementary_options_on_false') { return this.boolenaWithjustificationValue() }
    if (this.questionKind === 'radio_with_others_option') { return this.radioWithOthersField() }
    if (this.questionKind === 'date') { return this.dateFieldValue() }
    if (this.questionKind === 'state_select') { return this.stateSelectField() }
    if (this.questionKind === 'boolean_with_complementary_options_on_true') { return this.booleanWithComplementaryOptionsOnTrueValue() }
    if (this.questionKind === 'boolean_with_check_options_on_fase') { return this.booleanWithCheckOptionsOnFase() }
    if (this.questionKind === 'boolean_with_check_options_on_true') { return this.booleanWithCheckOptionsOnTrue() }
    if (this.questionKind === 'boolean_with_boolean_on_true') { return this.booleanWithBooleanOnTrue() }
    if (this.questionKind === 'boolean_with_radio_on_true') { return this.booleanWithRadioOnTrue() }
    if (this.questionKind === 'boolean_with_related_question') { return this.booleanWithRelatedQuestion() }
    if (this.questionKind === 'boolean_eliminatory_form_session') { return this.booleanWithEliminatoryFormSession() }
    if (this.questionKind === 'boolean_eliminatory_form') { return this.booleanWithEliminatoryForm() }


    console.log(`Unsuported field type ${this.questionKind}`)
    return undefined
  }

  textFieldValue() {
    return this.questionCard.getElementsByTagName('input')[0].value
  }

  textAreaFieldValue() {
    return this.questionCard.getElementsByTagName('textarea')[0].value
  }

  genderFieldValue() {
    const selectedGender = this.questionCard.querySelector('input[name="gender"]:checked')
    if (selectedGender) { return selectedGender.value }

    return null
  }

  radioFieldValue() {
    return this.questionCard.getElementsByTagName('select')[0].value
  }

  booleanFieldValue() {
    const elementQuery = `input[name="${this.questionId}-boolean"]:checked`
    const selectedValue = this.questionCard.querySelector(elementQuery)
    if (selectedValue) { return selectedValue.value }

    return null
  }

  booleanWithRelatedQuestion() {
    const elementQuery = `input[name="${this.questionId}-boolean"]:checked`
    const selectedValue = this.questionCard.querySelector(elementQuery)
    if (selectedValue) { return selectedValue.value }

    return null
  }

  booleanWithEliminatoryFormSession() {
    const elementQuery = `input[name="${this.questionId}-boolean-eliminatory-form-session"]:checked`
    const selectedValue = this.questionCard.querySelector(elementQuery)
    if (selectedValue) { return selectedValue.value }

    return null
  }

  booleanWithEliminatoryForm() {
    const elementQuery = `input[name="${this.questionId}-boolean-eliminatory-form"]:checked`
    const selectedValue = this.questionCard.querySelector(elementQuery)
    if (selectedValue) { return selectedValue.value }

    return null
  }

  checkWithOthersOptionFieldValue() {
    const checkedIds = this._getCheckedIds()
    const complementaryValue = document.getElementById(`${this.questionId}-others-field`).value
    return { value: checkedIds, complementaryValue }
  }

  checkFieldValue() {
    const checkedIds = this._getCheckedIds()
    return checkedIds.toString()
  }

  boolenaWithjustificationValue() {
    const radioButtonQuery = `input[name="${this.questionId}-boolean-with-justification"]:checked`
    const booleanField = this.questionCard.querySelector(radioButtonQuery)
    const complementaryValueField = document.getElementById(`${this.questionId}-complementary`)
    if (booleanField) {
      return { value: booleanField.value, complementaryValue: complementaryValueField.value }
    }

    return { value: null, complementaryValue: '' }
  }

  radioWithOthersField() {
    const value = this.questionCard.getElementsByTagName('select')[0].value
    const complementaryValue = document.getElementById(`${this.questionId}-others`).value
    if(value === '') { return { value: null, complementaryValue } }

    return { value, complementaryValue }
  }

  dateFieldValue() {
    return this.questionCard.getElementsByTagName('input')[0].value
  }

  stateSelectField() {
    return this.questionCard.getElementsByTagName('select')[0].value
  }

  booleanWithComplementaryOptionsOnTrueValue() {
    const radioButtonQuery = `input[name="${this.questionId}-boolean-with-justification"]:checked`
    const booleanField = this.questionCard.querySelector(radioButtonQuery)
    const complementaryValueField = document.getElementById(`${this.questionId}-complementary`)
    if (booleanField) {
      return { value: booleanField.value, complementaryValue: complementaryValueField.value }
    }

    return { value: null, complementaryValue: '' }
  }

  booleanWithCheckOptionsOnFase() {
    const radioButtonQuery = `input[name="${this.questionId}-boolean-with-check"]:checked`
    const booleanField = this.questionCard.querySelector(radioButtonQuery)
    const checkedIds = this._getCheckedIds()
    if (booleanField) {
      return { value: booleanField.value, complementaryValue: checkedIds.toString() }
    }

    return { value: null, complementaryValue: '' }
  }

  booleanWithCheckOptionsOnTrue() {
    const radioButtonQuery = `input[name="${this.questionId}-boolean-with-check"]:checked`
    const booleanField = this.questionCard.querySelector(radioButtonQuery)
    const checkedIds = this._getCheckedIds()
    if (booleanField) {
      return { value: booleanField.value, complementaryValue: checkedIds.toString() }
    }

    return { value: null, complementaryValue: '' }
  }

  booleanWithBooleanOnTrue() {
    const radioButtonQuery = `input[name="boolean-with-boolean-${this.questionId}"]:checked`
    const booleanField = this.questionCard.querySelector(radioButtonQuery)
    if(booleanField === null) return { value: null, complementaryValue: '' }

    const complementaryRadioButtonQuery = `input[name="${this.questionId}-boolean-with-boolean-justification"]:checked`
    const complementaryBooleanField = this.questionCard.querySelector(complementaryRadioButtonQuery)

    if (booleanField.value) {
      let complementaryValue = ''
      if (booleanField.value === 'Sim') {
        complementaryValue = complementaryBooleanField.value
      }

      return { value: booleanField.value, complementaryValue }
    }

    return { value: null, complementaryValue: '' }
  }

  booleanWithRadioOnTrue() {
    const radioButtonQuery = `input[name="${this.questionId}-boolean-with-radio-on-true"]:checked`
    const booleanField = this.questionCard.querySelector(radioButtonQuery)
    if(booleanField === null) return { value: null, complementaryValue: '' }

    const complementaryValue = this.questionCard.getElementsByTagName('select')[0].value
    return { value: booleanField.value, complementaryValue }
  }

  _getCheckedIds() {
    const checks = Array.from(this.questionCard.querySelectorAll('input[type=checkbox]'))
    const checkedFields = checks.filter(check => check.checked === true)
    return checkedFields.map(check => check.value)
  }
}
